<template>
  <footer class="platform-footer">
    <small class="platform-copyright">&copy; {{ year }} Vitrinis</small>
    <div class="platform-footer-links">
      <router-link to="/legal/terms">Terms</router-link>
      <router-link to="/login">Log In</router-link>
      <router-link v-if="SIGNUP_OPEN" to="/signup">Sign Up</router-link>
    </div>
  </footer>
</template>

<script>
// Hides the public Sign Up link; emailed invite links still work.
// Also set in PlatformNavbar.vue.
const SIGNUP_OPEN = false

export default {
  name: 'PlatformFooter',
  data() {
    return { SIGNUP_OPEN }
  },
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.platform-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  border-top: 1px solid var(--color-light-gray);
  background: var(--color-admin-bg);
  font-size: 0.85rem;
}

.platform-footer-links {
  display: flex;
  gap: 1.5rem;
}

.platform-footer-links a {
  color: var(--color-muted);
  text-decoration: none;
  transition: color 0.2s;
}

.platform-footer-links a:hover {
  color: var(--color-admin-text);
}

.platform-copyright {
  color: var(--color-muted);
}
</style>
